export default __webpack_public_path__ + "static/media/profile.5c9d0fe8.svg";